import { render, staticRenderFns } from "./newModelForm.vue?vue&type=template&id=075c2560"
import script from "./newModelForm.vue?vue&type=script&lang=js"
export * from "./newModelForm.vue?vue&type=script&lang=js"
import style0 from "./newModelForm.vue?vue&type=style&index=0&id=075c2560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports